<template>
  <AccordionRoot :collapsible="true" type="multiple">
    <AccordionItem
      :value="filter.id"
      :key="filter.id"
      class="p-4 relative bg-primary"
      :class="{
        'border-t': first(filters) !== filter,
      }"
      v-for="filter in filters"
    >
      <AccordionHeader>
        <AccordionTrigger
          class="flex pr-0.5 gap-2 items-center justify-between w-full cursor-pointer group ease-in-out border-secondary"
        >
          <div class="flex items-center justify-start grow gap-2">
            <div
              class="text-primary text-style-lg font-semibold leading-[28px]"
            >
              {{ filter.label }}
            </div>
            <Badge
              v-if="count(filter.id)"
              :label="count(filter.id)"
              type="modern"
              size="lg"
              number
            />
          </div>
          <div class="flex items-center justify-center">
            <Icon
              name="chevron-down"
              size="xl"
              class="ml-1 fg-secondary ease-in-out transition-transform duration-300 group-data-[state=open]:rotate-180"
            />
          </div>
        </AccordionTrigger>
      </AccordionHeader>
      <AccordionContent
        class="w-full bg-white pt-3 overflow-hidden data-[state=open]:animate-accordion-down data-[state=closed]:animate-accordion-up"
      >
        <div class="flex flex-col">
          <Group
            :key="filter.id"
            :handle="filter.id"
            :per_page="filter.type === 'date' ? null : 5"
            :type="filter.type"
            :label="filter.label"
            :multiple="filter.multiple"
            :options="filter.options"
            :count="count(filter.id)"
            :modelValue="filterStates[filter.id]"
            @update:modelValue="emit('update:filters', $event)"
          />
        </div>
      </AccordionContent>
    </AccordionItem>
  </AccordionRoot>
</template>

<script setup>
import { first, isEmpty, isArray } from "lodash";

import {
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionRoot,
  AccordionTrigger,
} from "radix-vue";
import { Icon } from "@/SharedComponents/Icon";
import { Group } from "@/SharedComponents/Filters/Drawer/Accordion";
import { Badge } from "@/SharedComponents/Badges";
import { FilterType } from "@/SharedComponents/Filters";

const emit = defineEmits(["update:filters"]);

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  filterStates: {
    type: Object,
    required: true,
  },
  filters: {
    type: Array,
    required: true,
  },
});

const count = (id) => {
  const state = props.filterStates[id];
  if (!state) return 0;

  if (isArray(state)) {
    if (id === FilterType.CATEGORY) {
      const filter = props.filters.find((item) => item.id === id);
      if (filter) {
        return filter.options.reduce((acc, option) => {
          if (
            option.ids?.some((id) => state.includes(id)) ||
            (!option.ids && state.includes(option.id))
          ) {
            acc++;
          }
          return acc;
        }, 0);
      }
    }
    return state.length;
  }

  return isEmpty(state) ? 0 : 1;
};
</script>
